import layout from '@/layout'

export default {
  path: '/log',
  component: layout,
  redirect: '/log/dongle/manage',
  name: 'dongleLog',
  meta: {
    title: '日志管理',
    icon: 'log'
  },
  children: [
    {
      path: '/log/dongle/manage',
      component: () => import('@/views/log-manage/dongle-log'),
      meta: {
        title: '加密狗日志',
        icon: 'file-lock'
      }
    },
    {
      path: '/log/dongle/:id',
      component: () => import('@/views/log-manage/dongle-log/info'),
      meta: {
        title: '加密狗日志详情'
      }
    }
  ]
}
